import {SECCIONES} from "../Constantes";
import {scrolearAComponente} from "./scrolearAComponente";

export const useIrRuta = () => {


    const ir = (secc) => {

        switch (secc) {
            case SECCIONES[0]:
                setTimeout(() => {
                    scrolearAComponente(SECCIONES[0])
                }, 500)
                break
            case SECCIONES[1]:
            case SECCIONES[2]:
                setTimeout(() => {
                    scrolearAComponente(SECCIONES[1])
                }, 500)
                break
            case SECCIONES[3]:
                setTimeout(() => {
                    scrolearAComponente(SECCIONES[3])
                }, 500)
                break

        }
    }

    return {
        ir
    }


}